import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import aiWhite from '../assets/images/aiWhite.svg';
import mdWhite from '../assets/images/mdWhite.svg';
import siWhite from '../assets/images/siWhite.svg';
import siWhite1 from '../assets/images/siWhite1.svg';
import obWhite from '../assets/images/obWhite.svg';
import ivWhite from '../assets/images/ivWhite.svg';
import pvWhite from '../assets/images/pvWhite.svg';
import assignWhite from '../assets/images/assignWhite.svg';
import mlWhite from '../assets/images/mlWhite.svg';
import warrantyWhite from '../assets/images/warrantyWhite.svg';
import supportWhite from '../assets/images/Support.svg';
import music from '../assets/images/music.svg';
import movie from '../assets/images/movie.svg';
import distributorSideLogo from '../assets/images/distributorSidebarLogo.svg';
import subscriptionsSideLogo from '../assets/images/subscriptionsSidebarLogo.svg';
import d2h from '../assets/images/d2h.svg';
import '../css/SidebarLeft.css';
import RoleWhite from '../assets/images/role_white.png';
import User_White from '../assets/images/user_white.png';
import MarketSpaceWhite from '../assets/images/marketSpace_white.png';

// side bar of all pages component


class SidebarLeft extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentAddress: '',
            activeSi: false,
            activeMd: false,
            activeAi: false,
            activeOb: false,
            activeMl: false,
            d2hMenuShow: false,
            moviveMenuShow: false,
            musicMenuShow: false,
            menuChannelShow: false,
            menuShowShow: false,
            okasBoxPageStatus: 'okasdashboard',
            versionPageStatus: 'internal'
        }
    }

    onClickHandler = (e) => {
        //console.log('called')
    }

    componentWillMount() {

        this.setState({
            // currentAddress: window.location.pathname
            currentAddress: window.location.pathname

        }, () => this.sideBarActivator())

        //code for sidebarleft for okasboxes pages
        if (window.location.pathname === '/okasboxes/dashboard') {
            this.setState({
                okasBoxPageStatus: 'okasdashboard'
            })
        }  else if (window.location.pathname === '/distributor') { //Dashboard 
            this.setState({
                okasBoxPageStatus: 'distributordashboard'
            })
        }  else if (window.location.pathname === '/distributor') { //Dashboard 
            this.setState({
                okasBoxPageStatus: 'distributordashboard'
            })
        }  else if (window.location.pathname === '/subscriptions') { //Subscriptions
            this.setState({
                okasBoxPageStatus: 'subscriptionsdashboard'
            })
        }  else if (window.location.pathname === './SubscriptionPlan') { //Subscription Plan
            this.setState({
                okasBoxPageStatus: 'subscriptionsdashboard'
            })
        } else if (window.location.pathname === './MarketSpace') { //Market Space
            this.setState({
                okasBoxPageStatus: 'marketspacedashboard'
            })
        }else if (window.location.pathname === './MarketSpaceForm') { //Market Space Form
            this.setState({
                okasBoxPageStatus: 'marketspacedashboard'
            })
        }else if (window.location.pathname === './MarketSpaceFormEdit') { //Market Space Form Edit
            this.setState({
                okasBoxPageStatus: 'marketspacedashboard'
            })
        } else if (window.location.pathname === './support') { //Subscription Plan
            this.setState({
                okasBoxPageStatus: 'support'
            })
        } else if (window.location.pathname === './role') { //Subscription Plan
            this.setState({
                okasBoxPageStatus: 'role'
            })
            
        }else if (window.location.pathname === './ota') { //Subscription Plan
            this.setState({
                okasBoxPageStatus: 'ota'
            })
            
        } else if (window.location.pathname === './user') { //Subscription Plan
            this.setState({
                okasBoxPageStatus: 'user'
            })
        }else if (window.location.pathname === './supportremoteaccess') { //Market Space Form Edit
            this.setState({
                okasBoxPageStatus: 'support'
            })
        }else if (window.location.pathname === './MarketSpaceDownload') { //Market Space Form
            this.setState({
                okasBoxPageStatus: 'marketspacedashboard'
            })
        }else if (window.location.pathname === '/memberlicense/dashboard') {
            this.setState({
                okasBoxPageStatus: 'memberlicensedashboard'
            })
        } else if (window.location.pathname === '/okasboxes/assignboxes') {
            this.setState({
                okasBoxPageStatus: 'assignboxes'
            })
        } else if (window.location.pathname === '/memberlicense/assignmemberlicense') {
            this.setState({
                okasBoxPageStatus: 'assignmemberlicense'
            })
        }  else if (window.location.pathname === '/distributor/Knowledge') {
            this.setState({
                okasBoxPageStatus: 'Knowledge'
            })
        }  else if (window.location.pathname === '/distributor/Video') {
            this.setState({
                okasBoxPageStatus: 'Video'
            })
        }   else if (window.location.pathname === '/distributor/UpcomingEvents') {
            this.setState({
                okasBoxPageStatus: 'UpcomingEvents'
            })
        }   else if (window.location.pathname === '/distributor/WhatsNew') {
            this.setState({
                okasBoxPageStatus: 'WhatsNew'
            })
        }else if (window.location.pathname === '/okasboxes/warrantystatus') {
            this.setState({
                okasBoxPageStatus: 'warranty'
            })
        } else if (window.location.pathname === '/version/internal') {
            this.setState({
                versionPageStatus: 'internal'
            })
        } else if (window.location.pathname === '/version/public') {
            this.setState({
                versionPageStatus: 'public'
            })
        } else if (window.location.pathname === '/ota') {
            this.setState({
                okasBoxPageStatus: 'OTA'
            })
        } else if (window.location.pathname === '/ota-beta') {
            this.setState({
                okasBoxPageStatus: 'OTA-update'
            })
        }
        else if (window.location.pathname === '/ota-crash-logs') {
            this.setState({
                okasBoxPageStatus: 'OTA-Crash-Logs'
            })
        }

    }



    toggleMenuBar = (value) => {
        if (value === 'd2h') {
            this.setState({
                d2hMenuShow: !this.state.d2hMenuShow,
                moviveMenuShow: false,
                musicMenuShow: false,
            })
        } else if (value === "movie") {
            this.setState({
                moviveMenuShow: !this.state.moviveMenuShow,
                d2hMenuShow: false,
                musicMenuShow: false,
            })
        } else if (value === 'music') {
            this.setState({
                musicMenuShow: !this.state.musicMenuShow,
                d2hMenuShow: false,
                moviveMenuShow: false,
            })
        } else if (value === 'channel') {
            this.setState({
                musicMenuShow: false,
                d2hMenuShow: true,
                moviveMenuShow: false,
                menuChannelShow: !this.state.menuChannelShow,
                menuShowShow: false,
            })
        } else if (value === 'shows') {
            this.setState({
                musicMenuShow: false,
                d2hMenuShow: true,
                moviveMenuShow: false,
                menuChannelShow: false,
                menuShowShow: !this.state.menuShowShow,
            })
        } else if (value === 'okasdashboard') {
            this.setState({
                okasBoxPageStatus: 'okasdashboard',
            })
        } else if (value === 'assignboxes') {
            this.setState({
                okasBoxPageStatus: 'assignboxes',
            })
        } else if (value === 'memberlicensedashboard') {
            this.setState({
                okasBoxPageStatus: 'memberlicensedashboard',
            })
        } else if (value === 'assignmemberlicense') {
            this.setState({
                okasBoxPageStatus: 'assignmemberlicense',
            })
        } else if (value === 'warranty') {
            this.setState({
                okasBoxPageStatus: 'warranty',
            })
        } else if (value === 'internalVersion') {
            this.setState({
                versionPageStatus: 'internal',
            })
        } else if (value === 'publicVersion') {
            this.setState({
                versionPageStatus: 'public',
            })
        }
    }

    sideBarLeftNew = () => {
        if (this.state.currentAddress === '/systemintegrator/system') {
            return (
                <div class="sidebar">
                    <a class="active">
                        <span style={{ height: '20px', width: '20px' }}>
                            <img src={siWhite1} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                        </span>
                        <span className="logo-label">
                            System Integrator
                </span>
                    </a>
                </div>
            )
        } else if (this.state.currentAddress === '/masterdevice/alldevice') {
            return (
                <React.Fragment>
                    <div class="sidebar">
                        <a class="active">
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={mdWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                            </span>
                            <span className="logo-label">
                                Master Devices
                </span>
                        </a>
                    </div>
                </React.Fragment>
            );
        } 
        // else if (this.state.currentAddress === '/distributor') {  // Distributor Dashboard
        //     return (
        //         <React.Fragment>
        //             <div class="sidebar">
        //                 <a class="active">
        //                     <span style={{ height: '20px', width: '20px' }}>
        //                         <img src={distributorSideLogo} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
        //                     </span>
        //                     <span className="logo-label">
        //                     Distributor
        //         </span>
        //                 </a>
        //             </div>
                    
        //         </React.Fragment>
        //     );
        // } 
        else if (this.state.currentAddress.indexOf('/distributor') !== -1) {
            return (
                <React.Fragment>
                    <div className="sidebar">
                        <a className={this.state.okasBoxPageStatus === 'distributordashboard' ? "active" : ""}>
                            <Link to="/distributor" onClick={this.toggleMenuBar.bind(this, 'distributordashboard')}>
                                <span style={{ height: '20px', width: '20px' }}>
                                    <img src={mlWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                                </span>
                                <span className="logo-label">
                                    Distributor
                </span>
                            </Link >
                        </a>
                        <a className={this.state.okasBoxPageStatus === 'Knowledge' ? "active" : ""}>
                            <Link to="/distributor/Knowledge" onClick={this.toggleMenuBar.bind(this, 'Knowledge')}>
                                <span style={{ height: '20px', width: '20px' }}>
                                    <img src={assignWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                                </span>
                                <span className="logo-label">
                                Knowledge Bank
                </span>
                            </Link>
                        </a>
                        <a className={this.state.okasBoxPageStatus === 'UpcomingEvents' ? "active" : ""}>
                            <Link to="/distributor/UpcomingEvents" onClick={this.toggleMenuBar.bind(this, 'UpcomingEvents')}>
                                <span style={{ height: '20px', width: '20px' }}>
                                    <img src={assignWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                                </span>
                                <span className="logo-label">
                                Upcoming Events
                </span>
                            </Link>
                        </a>
                        <a className={this.state.okasBoxPageStatus === 'Video' ? "active" : ""}>
                            <Link to="/distributor/Video" onClick={this.toggleMenuBar.bind(this, 'Video')}>
                                <span style={{ height: '20px', width: '20px' }}>
                                    <img src={assignWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                                </span>
                                <span className="logo-label">
                                Video
                </span>
                            </Link>
                        </a>
                        <a className={this.state.okasBoxPageStatus === 'WhatsNew' ? "active" : ""}>
                            <Link to="/distributor/WhatsNew" onClick={this.toggleMenuBar.bind(this, 'WhatsNew')}>
                                <span style={{ height: '20px', width: '20px' }}>
                                    <img src={assignWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                                </span>
                                <span className="logo-label">
                                What's New
                </span>
                            </Link>
                        </a>
                    </div>
                </React.Fragment>
            );
        }
        else if (this.state.currentAddress === '/OkasAdditionalInventoryRequest') {  // Okas Additional Inventory Request
            return (
                <React.Fragment>
                    <div class="sidebar">
                        <a class="active">
                            <span style={{ height: '20px', width: '20px' }}>
                            <img src={obWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                            </span>
                            <span className="logo-label">
                            OKAS Inventory
                </span>
                        </a>
                    </div>
                </React.Fragment>
            );
        } else if (this.state.currentAddress === '/subscriptions') {  // Subscriptions Dashboard
            return (
                <React.Fragment>
                    <div class="sidebar">
                        <a class="active">
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={subscriptionsSideLogo} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                            </span>
                            <span className="logo-label">
                            Subscriptions
                </span>
                        </a>
                    </div>
                </React.Fragment>
            );
        }else if (this.state.currentAddress === '/SubscriptionPlan') {  // Subscriptions Plan
            return (
                <React.Fragment>
                    <div class="sidebar">
                        <a class="active">
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={subscriptionsSideLogo} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                            </span>
                            <span className="logo-label">
                            Subscriptions
                </span>
                        </a>
                    </div>
                </React.Fragment>
            );
        }else if (this.state.currentAddress === '/marketspace') {  // Market Space
            return (
                <React.Fragment>
                    <div class="sidebar">
                        <a class="active">
                            <span style={{ height: '20px', width: '20px' }}> 
                                <img src={MarketSpaceWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />  
                            </span>
                            <span className="logo-label">
                            Market Place
                </span>
                        </a>
                    </div>
                </React.Fragment>
            );
        }else if (this.state.currentAddress === '/marketspaceForm') {  // Market Space form
            return (
                <React.Fragment>
                    <div class="sidebar">
                        <a class="active">
                            <span style={{ height: '20px', width: '20px' }}> 
                                <img src={MarketSpaceWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />  
                            </span>
                            <span className="logo-label">
                            Market Place
                </span>
                        </a>
                    </div>
                </React.Fragment>
            );
        }else if (this.state.currentAddress === '/marketspaceFormEdit') {  // Market Space form Edit
            return (
                <React.Fragment>
                    <div class="sidebar">
                        <a class="active">
                            <span style={{ height: '20px', width: '20px' }}> 
                                <img src={MarketSpaceWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />  
                            </span>
                            <span className="logo-label">
                            Market Place
                </span>
                        </a>
                    </div>
                </React.Fragment>
            );
        }else if (this.state.currentAddress === '/marketspacedownload') {  // Market Space download
            return (
                <React.Fragment>
                    <div class="sidebar">
                        <a class="active">
                            <span style={{ height: '20px', width: '20px' }}> 
                                <img src={MarketSpaceWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />  
                            </span>
                            <span className="logo-label">
                            Market Place
                </span>
                        </a>
                    </div>
                </React.Fragment>
            );
        }   else if (this.state.currentAddress === '/role') {
            return (
                <div class="sidebar">
                    <a class="active" >
                        {/* <Link to="/role"> */}
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={RoleWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                Roles
                </span>
                        {/* </Link> */}
                    </a>
                
                </div>
            );
        }
        // else if (this.state.currentAddress === '/ota-crash-logs') {
        //     return (
        //         <div class="sidebar">
        //             <a class="active" >
        //                 {/* <Link to="/role"> */}
        //                     <span style={{ height: '20px', width: '20px' }}>
        //                         <img src={RoleWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
        //                     </span>
        //                     <span className="logo-label">
        //                         ota-crash-logs
        //         </span>
        //                 {/* </Link> */}
        //             </a>
                
        //         </div>
        //     );
        // }
        else if (this.state.currentAddress === '/ota' || this.state.currentAddress === '/ota-beta' || this.state.currentAddress === '/ota-crash-logs') {
            return (
                <div class="sidebar">
                    <a class={this.state.okasBoxPageStatus === 'OTA' ? "active" : ""} href='/ota' >
                        {/* <Link to="/role"> */}
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={RoleWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                OTA Update
                </span>
                        {/* </Link> */}
                    </a>
                    <a class={this.state.okasBoxPageStatus === 'OTA-update' ? "active" : ""} href='/ota-beta' >
                        {/* <Link to="/role"> */}
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={RoleWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                OTA Beta Update
                </span>
                        {/* </Link> */}
                    </a>
                    <a class={this.state.okasBoxPageStatus === 'OTA-Crash-Logs' ? "active" : ""} href='/ota-crash-logs' >
                        {/* <Link to="/role"> */}
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={RoleWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                OTA Crash Logs
                            </span>
                        {/* </Link> */}
                    </a>
                
                </div>
            );
        }
        else if (this.state.currentAddress === '/ota' || this.state.currentAddress === '/ota-beta' || this.state.currentAddress === '/ota-crash-logs') {
            return (
                <div class="sidebar">
                    <a class={this.state.okasBoxPageStatus === 'OTA' ? "active" : ""} href='/ota' >
                        {/* <Link to="/role"> */}
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={RoleWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                OTA Update
                </span>
                        {/* </Link> */}
                        </a>
                        <a class={this.state.okasBoxPageStatus === 'OTA-update' ? "active" : ""} href='/ota-beta' >
                            {/* <Link to="/role"> */}
                                <span style={{ height: '20px', width: '20px' }}>
                                    <img src={RoleWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                                </span>
                                <span className="logo-label">
                                    OTA Beta Update
                    </span>
                            {/* </Link> */}
                    </a>
                    <a class={this.state.okasBoxPageStatus === 'OTA-Crash-Logs' ? "active" : ""} href='/ota-crash-logs' >
                        {/* <Link to="/role"> */}
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={RoleWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                OTA Crash Logs
                            </span>
                        {/* </Link> */}
                    </a>
                </div>
            );
        }
        else if (this.state.currentAddress === '/ota-beta' || this.state.currentAddress === '/ota' || this.state.currentAddress === '/ota-crash-logs') {
            return (
                <div class="sidebar">
                    <a class="active" >
                        {/* <Link to="/role"> */}
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={RoleWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                OTA Beta Update
                </span>
                        {/* </Link> */}
                    </a>
                    <a class={this.state.okasBoxPageStatus === 'OTA-Crash-Logs' ? "active" : ""} href='/ota-crash-logs' >
                        {/* <Link to="/role"> */}
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={RoleWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                OTA Crash Logs
                            </span>
                        {/* </Link> */}
                    </a>
                
                </div>
            );
        }
          else if (this.state.currentAddress === '/user') {
            return (
                <div class="sidebar">
                    <a class="active" >
                        {/* <Link to="/user"> */}
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={User_White} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                Users
                </span>
                        {/* </Link> */}
                    </a>
                
                </div>
            );
        } else if (this.state.currentAddress === '/support') {
            return (
                <div class="sidebar">
                    <a class="active" >
                        {/* <Link to="/support"> */}
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={supportWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                Support
                </span>
                        {/* </Link> */}
                    </a>
                
                </div>
            );
        } else if (this.state.currentAddress.startsWith('/supportremoteaccess')) {
            return (
                <React.Fragment>
                <div class="sidebar">
                    <a class="active" >
                 
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={supportWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                Support
                </span>
            
                     
                    </a>
                
                </div>
                </React.Fragment>
            );
        } else if (this.state.currentAddress.startsWith('/designstudioremoteaccess')) {
            return (
                <React.Fragment>
                <div class="sidebar">
                    <a class="active" >
                 
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={supportWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} className="logo-sidenav" />
                            </span>
                            <span className="logo-label">
                                Support
                </span>
            
                     
                    </a>
                
                </div>
                </React.Fragment>
            );
        } else if (this.state.currentAddress.indexOf('/version') !== -1) {
            return (
                <div className="sidebar">
                    <a className={this.state.versionPageStatus === 'internal' ? "active" : ""}>
                        <Link to="/version/internal" onClick={this.toggleMenuBar.bind(this, 'internalVersion')}>
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={ivWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                            </span>
                            <span className="logo-label">
                                Internal Version
            </span>
                        </Link >
                    </a>
                    <a className={this.state.versionPageStatus === 'public' ? "active" : ""}>
                        <Link to="/version/public" onClick={this.toggleMenuBar.bind(this, 'publicVersion')}>
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={pvWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                            </span>
                            <span className="logo-label">
                                Public Version
            </span>
                        </Link>
                    </a>
                </div>
            );
        } else if (this.state.currentAddress.indexOf('/okasboxes') !== -1) {
            return (
                // <div class="sidebar">
                // <a className={this.state.okasBoxPageStatus==='okasdashboard' ? "active" : ""} style={{minHeight: '3%', paddingBottom: '.75%', paddingTop: '.75%'}}> 
                // <Link to="/okasboxes/dashboard" onClick={this.toggleMenuBar.bind(this,'okasdashboard')}>
                //     <span className="">
                //         <img src={obWhite} className="logo-sidenav"/>
                //     </span>
                //     <span className="logo-label">
                //     OKAS Boxes
                //     </span>
                // </Link >
                // </a>
                // <a className={this.state.okasBoxPageStatus==='assignboxes' ? "active" : ""} style={{minHeight: '3%', paddingBottom: '.75%', paddingTop: '.75%'}}> 
                // <Link to="/okasboxes/assignboxes" onClick={this.toggleMenuBar.bind(this,'assignboxes')}>
                //     <span className="">
                //         <img src={assignWhite} className="logo-sidenav"/>
                //     </span>
                //     <span className="logo-label">
                //              Assign OKAS Boxes
                //     </span>
                //     </Link>
                // </a>
                // </div>
                <React.Fragment>
                    <div className="sidebar">
                        <a className={this.state.okasBoxPageStatus === 'okasdashboard' ? "active" : ""}>
                            <Link to="/okasboxes/dashboard" onClick={this.toggleMenuBar.bind(this, 'okasdashboard')}>
                                <span style={{ height: '20px', width: '20px' }}>
                                    <img src={obWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                                </span>
                                <span className="logo-label">
                                OKAS Inventory
                </span>
                            </Link >
                        </a>
                        <a className={this.state.okasBoxPageStatus === 'assignboxes' ? "active" : ""}>
                            <Link to="/okasboxes/assignboxes" onClick={this.toggleMenuBar.bind(this, 'assignboxes')}>
                                <span style={{ height: '20px', width: '20px' }}>
                                    <img src={assignWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                                </span>
                                <span className="logo-label">
                                    Assign OKAS Inventory
                </span>
                            </Link>
                        </a>
                    </div>
                </React.Fragment>
            );
        }else if (this.state.currentAddress.indexOf('/memberlicense') !== -1) {
            return (
                <React.Fragment>
                    <div className="sidebar">
                        <a className={this.state.okasBoxPageStatus === 'memberlicensedashboard' ? "active" : ""}>
                            <Link to="/memberlicense/dashboard" onClick={this.toggleMenuBar.bind(this, 'memberlicensedashboard')}>
                                <span style={{ height: '20px', width: '20px' }}>
                                    <img src={mlWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                                </span>
                                <span className="logo-label">
                                    Member License
                </span>
                            </Link >
                        </a>
                        <a className={this.state.okasBoxPageStatus === 'assignmemberlicense' ? "active" : ""}>
                            <Link to="/memberlicense/assignmemberlicense" onClick={this.toggleMenuBar.bind(this, 'assignmemberlicense')}>
                                <span style={{ height: '20px', width: '20px' }}>
                                    <img src={assignWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                                </span>
                                <span className="logo-label">
                                Assign License
                </span>
                            </Link>
                        </a>
                    </div>
                </React.Fragment>
            );
        } else if (this.state.currentAddress.indexOf('/ai/') !== -1) {
            return (
                // <div class="sidebar">
                // <a className={this.state.currentAddress.indexOf('/ai/dashboard')!==-1 ? "active" : ""} >
                // <Link to="/ai/dashboard">
                //     <span>
                //         <img src={aiWhite} className="logo-sidenav"/>
                //     </span>
                //     <span className="logo-label">
                //         Artificial Intelligence
                //     </span>
                // </Link>
                // </a>
                // <a onClick={this.toggleMenuBar.bind(this,'d2h')}> 
                //     <span className="underMenu">
                //         <img src={d2h} className="logo-sidenav-underMenu"/>
                //     </span>
                //     <span className="logo-label">
                //         D2H
                //     </span>
                // </a>
                // {this.menuForD2H()}
                // <a onClick={this.toggleMenuBar.bind(this,'movie')}>
                //     <span  className="underMenu">
                //         <img src={movie} className="logo-sidenav-underMenu"/>
                //     </span>
                //     <span className="logo-label">
                //         Movie
                //     </span>
                // </a>
                // {this.menuForMovies()}
                // <a onClick={this.toggleMenuBar.bind(this,'music')}>
                //     <span  className="underMenu">
                //         <img src={music} className="logo-sidenav-underMenu"/>
                //     </span>
                //     <span className="logo-label">
                //         Music
                //     </span>
                // </a>
                // {this.menuForMusic()}
                // </div>
                <div class="sidebar">
                    <a className={this.state.currentAddress.indexOf('/ai/dashboard') !== -1 ? "active" : ""}>
                        <Link to="/ai/dashboard">
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={aiWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                            </span>
                            <span className="logo-label">
                                Artificial Intelligence
                </span>
                        </Link>
                    </a>
                    <a onClick={this.toggleMenuBar.bind(this, 'd2h')}>                       
                            <span style={{ height: '20px', width: '20px' }}>
                                <img src={d2h} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                            </span>
                            <span className="logo-label">
                                D2H
                            </span>
                        
                    </a>
                    {this.menuForD2H()}
                    <a onClick={this.toggleMenuBar.bind(this, 'movie')}>
                        <span style={{ height: '20px', width: '20px' }}>
                        <img src={movie} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                        </span>
                        <span className="logo-label">
                            Movie
                </span>
                    </a>
                    {this.menuForMovies()}
                                        <a onClick={this.toggleMenuBar.bind(this, 'music')}>
                        <span style={{ height: '20px', width: '20px' }}>
                            <img src={music} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                        </span>
                        <span className="logo-label">
                            Music
                </span>
                    </a>
                    {this.menuForMusic()}
                </div>
            );
        }
        else {
            return null
        }

    }

    menuForD2H = () => {
        if (this.state.d2hMenuShow) {
            return (
                <React.Fragment>
                    {/* <a onClick={this.toggleMenuBar.bind(this, 'channel')}>
                        <span className="underSubMenu">
                            <img src={mdWhite} className="logo-sidenav-underMenu" />
                        </span>
                        <span className="logo-label">
                            Channel
                </span>
                    </a> */}
                    <a onClick={this.toggleMenuBar.bind(this, 'channel')} style={{paddingLeft: '20px'}}>
                        <span style={{ height: '20px', width: '20px' }}>
                            <img src={mdWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                        </span>
                        <span className="logo-label">
                            Channel
                </span>
                    </a>
                    {this.subMenuChannel()}
                    <a onClick={this.toggleMenuBar.bind(this, 'shows')} style={{paddingLeft: '20px'}}>
                        <span  style={{ height: '20px', width: '20px' }}>
                            <img src={mdWhite} style={{ height: 'inherit', width: 'inherit', margin: '12.5px' }} />
                        </span>
                        <span className="logo-label">
                            Shows
                </span>
                    </a>
                    {this.subMenuShows()}
                </React.Fragment>
            );
        }
    }

    menuForMusic = () => {
        if (this.state.musicMenuShow) {
            return (
                <React.Fragment>
                    <a className={window.location.pathname === '/ai/music' ? "subMenuBarNoIcon active" : 'subMenuBarNoIcon '}>
                        <Link to="/ai/music">
                            <span className="logo-label logo-label-submenu">
                                AI Music User Data
                </span>
                        </Link>
                    </a>
                    <a className={window.location.pathname === '/ai/musicpushdata' ? "subMenuBarNoIcon active" : 'subMenuBarNoIcon '}>
                        <Link to="/ai/musicpushdata">
                            <span className="logo-label logo-label-submenu">
                                AI Music Recommendations
                </span>
                        </Link>
                    </a>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    menuForMovies = () => {
        if (this.state.moviveMenuShow) {
            return (
                <React.Fragment>
                    <a className={window.location.pathname === '/ai/movies' ? "subMenuBarNoIcon active" : 'subMenuBarNoIcon '}>
                        <Link to="/ai/movies">
                            <span className="logo-label-submenu-first">
                                AI Movie User Data
                </span>
                        </Link>
                    </a>
                    <a className={window.location.pathname === '/ai/moviespushdata' ? "subMenuBarNoIcon active" : 'subMenuBarNoIcon '}>
                        <Link to="/ai/moviespushdata">
                            <span className="logo-label-submenu-first">
                                AI Movies Recommendations
                </span>
                        </Link>
                    </a>
                </React.Fragment>
            );
        }
    }

    subMenuChannel = () => {
        if (this.state.d2hMenuShow && this.state.menuChannelShow) {
            return (
                <React.Fragment>
                    {/* <a className={window.location.pathname === '/ai/addchannel' || window.location.pathname === '/ai/addnewchannel' || window.location.pathname === '/ai/editchannel/' ? "subMenuBarNoIcon active" : 'subMenuBarNoIcon '}>
                        <Link to="/ai/addchannel">
                            <span className="logo-label logo-label-submenu">
                                Add / Edit Channel
                    </span>
                        </Link>
                    </a> */}
                    {/* <a className={window.location.pathname === '/ai/d2h' ? "subMenuBarNoIcon active" : 'subMenuBarNoIcon '}>
                        <Link to="/ai/d2h">
                            <span className="logo-label logo-label-submenu">
                                D2H User Data
                    </span>
                        </Link>
                    </a>
                    <a className={window.location.pathname === '/ai/pushdata' ? "subMenuBarNoIcon active" : 'subMenuBarNoIcon '}>
                        <Link to="/ai/pushdata">
                            <span className="logo-label logo-label-submenu">
                                D2H Recommendations
                    </span>
                        </Link>
                    </a> */}
                    <a className={window.location.pathname === '/ai/d2hlist' ? "subMenuBarNoIcon active" : 'subMenuBarNoIcon '}>
                        <Link to="/ai/d2hlist">
                            <span className="logo-label logo-label-submenu">
                                D2H List
                    </span>
                        </Link>
                    </a>
                </React.Fragment>
            );
        }
    }


    sideBarActivator = () => {
        if (this.state.currentAddress === "/ai/addchannel" || window.location.pathname === '/ai/addnewchannel' || this.state.currentAddress === "/ai/editchannel/" || this.state.currentAddress === '/ai/d2h' || this.state.currentAddress === '/ai/pushdata' || this.state.currentAddress === '/ai/d2hlist') {
            this.setState({
                menuChannelShow: true,
                d2hMenuShow: true
            })
        }

        if (this.state.currentAddress === "/ai/misc" || this.state.currentAddress === '/ai/showsai' || this.state.currentAddress === '/ai/showsaipush') {
            this.setState({
                menuShowShow: true,
                d2hMenuShow: true
            })
        }

        if (this.state.currentAddress === "/ai/movies" || this.state.currentAddress === '/ai/moviespushdata') {
            this.setState({
                moviveMenuShow: true,
            })
        }
        if (this.state.currentAddress === "/ai/music" || this.state.currentAddress === '/ai/musicpushdata') {
            this.setState({
                musicMenuShow: true,
            })
        }
    }


    subMenuShows = () => {
        if (this.state.d2hMenuShow && this.state.menuShowShow) {
            return (
                <React.Fragment>
                    <a className={window.location.pathname === '/ai/misc' ? "subMenuBarNoIcon active" : 'subMenuBarNoIcon '}>
                        <Link to="/ai/misc">
                            <span className="logo-label logo-label-submenu">
                                D2H Shows
                    </span>
                        </Link>
                    </a>
                    {/* <a className={window.location.pathname === '/ai/showsai' ? "subMenuBarNoIcon active" : 'subMenuBarNoIcon '}>
                        <Link to="/ai/showsai">
                            <span className="logo-label logo-label-submenu">
                                User Data
                </span>
                        </Link>
                    </a>
                    <a className={window.location.pathname === '/ai/showsaipush' ? "subMenuBarNoIcon active" : 'subMenuBarNoIcon '}>
                        <Link to="/ai/showsaipush">
                            <span className="logo-label logo-label-submenu">
                                AI Recommendations
                    </span>
                        </Link>
                    </a> */}
                </React.Fragment>
            );
        }
    }

    render() {
        return (
            <div>
                {this.sideBarLeftNew()}
            </div>
        )
    }
}

export default SidebarLeft;
